export default __webpack_public_path__ + "static/media/Create-documentation.727a8632.md";